module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAQAAACQTsNJAAAAtElEQVR42u2WQQ6DIBBFjV6FU3AAvQFsiBs9AiRd6QV659dNY9sUBjQlbVKZDQTywvxZ/N80NRYKzSCURsmADofH0AtlWAh0aUhgpM3+tWXEpRtZ84g7xieaQmOLlTPo+EXPhXk7zY999O2QhkxPkOkYZChu538g1/f6EuScTpGwcYGrQ87p7BL2VdzqkF/R5COWofDF5rUkHRlXbKNBMvTAihVTgcXjBEPfooWUCnLR4ui6AewpebRXHMRzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/baseloan/assets/icon-tab-02.png
// module id = Zsbu
// module chunks = 70